import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { prefersReducedMotion } from '../utils/motion'

gsap.registerPlugin(ScrollTrigger)

let pageNavController = null
let pageNavTriggers = []

export default function initPageNav() {
	pageNavController?.abort()
	pageNavController = new AbortController()
	const { signal } = pageNavController

	pageNavTriggers.forEach((trigger) => trigger.kill())
	pageNavTriggers = []

	const pageNavLinks = document.querySelectorAll('.page-nav-link')
	const pageNavTargets = document.querySelectorAll('.page-nav-target')

	if (!pageNavLinks.length || !pageNavTargets.length) return

	const setActiveLink = (anchorID) => {
		pageNavLinks.forEach((link) => {
			link.classList.toggle('is-active', link.dataset.target === anchorID)
		})
	}

	// MARK: Add active state to links
	pageNavTargets.forEach((target) => {
		const anchorID = target.id

		if (!anchorID) return

		const pageNavTrigger = ScrollTrigger.create({
			trigger: target,
			start: '0% 50%',
			end: '100% 50%',
			onEnter: () => {
				setActiveLink(anchorID)
			},
			onEnterBack: () => {
				setActiveLink(anchorID)
			},
		})

		pageNavTriggers.push(pageNavTrigger)
	})

	// MARK: Scroll to link target
	pageNavLinks.forEach((link) => {
		const target = document.getElementById(link.dataset.target)

		if (!target) return

		link.addEventListener('click', (event) => {
			event.preventDefault()

			let headerHeight = document.querySelector('.site-header')?.offsetHeight || 0
			let targetTopDistance = window.scrollY + target.getBoundingClientRect().top
			let targetTopPadding = parseInt(getComputedStyle(target).paddingTop, 10)
			let bodyFontSize = parseInt(getComputedStyle(document.body).fontSize, 10)
			let extraOffset = targetTopPadding - (bodyFontSize * 2.8)
			let behavior = prefersReducedMotion() ? 'auto' : 'smooth'

			if (target.classList.contains('form-block-full')) {
				window.scrollTo({
					top: targetTopDistance - headerHeight,
					behavior,
				})
			} else {
				window.scrollTo({
					top: targetTopDistance - headerHeight + extraOffset,
					behavior,
				})
			}
		}, { signal })
	})
}
